import { sleep, getStorageData } from '@/utils/util';
import { getUserInfo, getAppGlobalInfo } from '@/api/user';
import { logout } from '@/api/login';

const resetState = {
	isLogin: false,
	userName: '',
	userId: '',
	type: 0,
	points: 0,
	photo: '',
	userToken: '',
	loginType: null,
	hasCheckIn: false
};

const actions = {
	async updateUserInfo({ commit, state, rootState }, payload) {
		const userToken = await getStorageData('user_token');

		if (!userToken) {
			commit('UPDATE_USER_INFO', {
				...resetState
			});
			return;
		}

		try {
			const res = await getUserInfo({
				token: userToken
			});
			const appGlobalInfo = await getAppGlobalInfo({
				token: userToken
			});

			if (res.code === 0) {
				commit('UPDATE_USER_INFO', {
					isLogin: true,
					userName: res.data.nickname,
					photo: res.data.avatar,
					points: res.data.balance,
					userId: res.data.fake_id,
					loginType: res.data.register_channel,
					hasCampaignsNotify: appGlobalInfo.data.campaigns_notify,
					userToken
				});
				return;
			}

			commit('UPDATE_USER_INFO', {
				...resetState
			});
		}
		catch(err) {
			commit('UPDATE_USER_INFO', {
				...resetState
			});
		}
	},

	async updateInviteCode({ commit, state, rootState }, payload) {
		commit('UPDATE_INVITE_CODE', {
			inviteCode: payload.inviteCode || ''
		});
	},

	async updateUserToken({ commit, state, rootState }, payload) {
		commit('UPDATE_USER_TOKEN', {
			userToken: payload.userToken || ''
		});
	},
}

export default actions;
